import {
  login as loginRequest,
  logout as logoutRequest,
  refreshSession as refreshSessionRequest,
  validateSession as validateSessionRequest,
} from "@vetty/api-sdk";
import {
  axiosInstance,
  genericAuthRequestErrorMessage,
  handleAxiosError,
} from "./axiosInstance.helper";
import { stripAuthTokensFromClientPayload } from "./strip-auth-tokens.helper";
import { ApiResponse, UserRole } from "@/types";

export const validateSession = async (): Promise<null | {
  id: string;
  email: string;
  onboardingCompleted: boolean;
  role: UserRole;
  subscriptionId: string | null;
}> => {
  try {
    const { data } = await validateSessionRequest(axiosInstance);

    if (data && (data as ApiResponse).success) {
      return stripAuthTokensFromClientPayload((data as ApiResponse).data);
    }

    return null;
  } catch (error: unknown) {
    return null;
  }
};

export const refreshSession = async (): Promise<null | {
  id: string;
  email: string;
  onboardingCompleted: boolean;
  role: UserRole;
  subscriptionId: string | null;
}> => {
  try {
    const { data } = await refreshSessionRequest(axiosInstance);

    if (data && (data as ApiResponse).success) {
      return stripAuthTokensFromClientPayload((data as ApiResponse).data);
    }

    return null;
  } catch (error: unknown) {
    return null;
  }
};

export const loginUser = async (
  email: string,
  password: string
): Promise<ApiResponse | null> => {
  try {
    const { data } = await loginRequest(axiosInstance, {
      email,
      password,
    });

    if (data && (data as ApiResponse).success) {
      return stripAuthTokensFromClientPayload(data as ApiResponse);
    }

    return null;
  } catch (error: unknown) {
    const api = handleAxiosError(error);
    if (!api) {
      return {
        success: false,
        code: "request_failed",
        message: genericAuthRequestErrorMessage,
      } as ApiResponse;
    }
    return {
      ...api,
      message:
        typeof api.message === "string" && api.message.trim()
          ? api.message
          : genericAuthRequestErrorMessage,
    };
  }
};

export const logoutUser = async (): Promise<ApiResponse | null> => {
  try {
    const { data } = await logoutRequest(axiosInstance);
    const locale =
      typeof window !== "undefined"
        ? window.location.pathname.split("/")[1] || "en"
        : "en";
    window.location.href = `/${locale}/login`;
    return data as ApiResponse;
  } catch (error: unknown) {
    const locale =
      typeof window !== "undefined"
        ? window.location.pathname.split("/")[1] || "en"
        : "en";
    window.location.href = `/${locale}/login`;
    return handleAxiosError(error);
  }
};
